import * as XLSX from 'xlsx';

const mapProductStatus = (isActive) => {
  return isActive ? 'فعال' : 'غیرفعال';
};

const mapInventoryStatus = (isActive) => {
  return isActive ? 'فعال' : 'غیرفعال';
};

export const exportAdminInventoryExcel = (rows = []) => {
  const UNIT_TRANSLATIONS = {
    count: "عدد",
    package: "بسته",
    weight: "کیلوگرم",
    length: "متر",
    area: "متر مربع",
    litr: "لیتر",
    volume: "متر مکعب",
  };
  const excelRows = rows.map((item) => ({
    'نام کالا': item?.name ?? '-',
    'کد کالا': item?.product_code ?? '-',
    'شناسه کالا (id)': item?.id ?? '-',
    'وضعیت کالا': mapProductStatus(item?.is_active),
    'واحد اندازه‌گیری': UNIT_TRANSLATIONS[item?.unit_of_measure] ?? '-',
    'دسته': item?.category_name ?? '-',
    'برند': item?.brand ?? '-',
    'تأمین کننده': item?.supplier?.full_name ?? '-',
    'انبار': item?.warehouse?.title ?? '-',
    'موجودی': item?.stock ?? 0,
    'قیمت': item?.price ?? 0,
    'تخفیف': item?.discount_percent ?? 0,
    'حداقل سفارش': item?.min_order ?? '-',
    'ضریب سفارش': item?.order_multiple ?? '-',
    'وضعیت موجودی': mapInventoryStatus(item?.inventory_is_active),
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelRows);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'AdminInventory');

  XLSX.writeFile(workbook, `admin-inventory-${Date.now()}.xlsx`);
};
